module.exports = __webpack_public_path__ + "img/argumentlogo.e1b7e080.png";